import { fr } from './fr';
import { nl } from './nl';
import { en } from './en';

export const translations = {
  fr,
  nl,
  en
}; 